export const CMRI_OVERVIEW_PAGE_CONST = {
    localStorage: {
        sidebarCollapsedKey: 'cmriOverviewSidebarCollapsed',
    },
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)', // Adjusted to match the height of the sidebar content
};
